<template>
    <v-card elevation="0">
        <v-card-text>
            <v-tabs
                background-color="white"
                color="dark"
                show-arrows="mobile"
                v-model="shippingOptionTab">
                    <v-tab href="#configuration">Configuration</v-tab>
                    <v-tab href="#carriers" :disabled="shippingOption.id == ''">Carriers</v-tab>
                    <v-tab href="#pricing-rules" :disabled="shippingOption.id == ''">Pricing Rules</v-tab>

                    <v-tab-item class="pt-5" value="configuration">
                        <v-row>
                            <v-col cols="12">
                                <v-card elevation="0">
                                    <v-card-actions>
                                        <v-switch
                                            v-model="shippingOption.enabled"
                                            label="Enabled">
                                        </v-switch>
                                        <v-spacer></v-spacer>
                                        <v-btn :disabled="isSaving" small @click="$emit('close-form')">Close</v-btn>
                                        <v-btn :disabled="isSaving" small color="primary" @click="saveShippingOption">
                                            <span v-if="isSaving">
                                                <v-progress-circular
                                                    indeterminate
                                                    size="12"
                                                    width="2"
                                                    color="primary darken-3">
                                                </v-progress-circular>
                                                Saving...
                                            </span>
                                            <span v-else>Save</span>
                                        </v-btn>
                                    </v-card-actions>
                                    <v-card-text>

                                        <v-row>
                                            <v-text-field
                                                v-model="shippingOption.label"
                                                label="Label"
                                                :error-messages="getLabelErrors"
                                                @blur="$v.shippingOption.label.$touch()"
                                            ></v-text-field>
                                        </v-row>

                                        <v-row>
                                            <v-textarea v-model="shippingOption.description" label="Description"></v-textarea>
                                        </v-row>

                                        <v-row>
                                            <v-select
                                                v-model="shippingOption.question_ids"
                                                :items="questionIds"
                                                label="Question Ids"
                                                class="mt-4"
                                                multiple
                                                chips
                                                item-text="text"
                                                item-value="value"
                                                clearable
                                                small-chips
                                            >
                                                <template v-slot:selection="data">
                                                    <v-chip
                                                        v-bind="data.attrs"
                                                        :input-value="data.selected"
                                                        close
                                                        @click:close="data.parent.selectItem(data.item)"
                                                        small
                                                        :title="getSelectedQuestion(data).value"
                                                    >
                                                        {{ getSelectedQuestion(data).text }}
                                                    </v-chip>
                                                </template>
                                            </v-select>
                                        </v-row>

                                        <Conditions :conditions="shippingOption.conditions" />

                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn :disabled="isSaving" small @click="$emit('close-form')">Close</v-btn>
                                        <v-btn :disabled="isSaving" small color="primary" @click="saveShippingOption">
                                            <span v-if="isSaving">
                                                <v-progress-circular
                                                    indeterminate
                                                    size="12"
                                                    width="2"
                                                    color="primary darken-3">
                                                </v-progress-circular>
                                                Saving...
                                            </span>
                                            <span v-else>Save</span>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                        </v-col>
                    </v-row>
                    </v-tab-item>

                    <v-tab-item class="pt-5" value="carriers">
                        <Carriers @save-shipping-option="saveShippingOption" :selectedShippingOption="this.shippingOption" />
                    </v-tab-item>
                    <v-tab-item class="pt-5" value="pricing-rules">
                        <PricingRules @save-shipping-option="saveShippingOption" :selectedShippingOption="this.shippingOption" />
                    </v-tab-item>
            </v-tabs>
        </v-card-text>
    </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { EventBus } from '@/js/event-bus.js'
import Carriers from './Carriers';
import PricingRules from './PricingRules';
import Conditions from './components/Conditions';
import { ShippingOptionStruct } from '@/js/components/integrations/tabs/liverate-settings/shipping-options/ShippingOptionStruct.js';
import store from '@/js/store/index.js';
export default {

    props: {
        integrationId: {
            type: Number,
            required: true
        },
        selectedShippingOption: {
            type: ShippingOptionStruct,
            required: true
        },
        questionIds: {
            type: Array,
            default: () => []
        }
    },

    components: {
        Carriers,
        PricingRules,
        Conditions,
    },

    data() {
        return {
            shippingOptionTab: 'configuration',
            shippingOption: this.selectedShippingOption,
            isSaving: false
        }
    },

    validations: {
        shippingOption: {
            label: { required },
        },
    },

    computed: {
        getLabelErrors() {
            const labelValidation = this.$v.shippingOption.label;
            if (!labelValidation.$dirty) return [];
            return !labelValidation.required ? ['Label is required'] : [];
        }
    },

    methods: {

        getSelectedQuestion(data) {
            return {
                text: data.item?.text ?? data,
                value: data.item?.value ?? data
            }
        },

        saveShippingOption() {

            this.$v.$touch();

            if (this.$v.$invalid) {
                EventBus.$emit('show-error', 'Please complete the required fields.');
                return;
            }

            this.isSaving = true;

            const baseUrl = '/api/shipping-options/' + this.integrationId;
            const url = this.shippingOption.id
                ? `${baseUrl}/${this.shippingOption.id}`
                : baseUrl;

            const method = this.shippingOption.id ? 'put' : 'post';

            const payload = this.shippingOption;

            // send only the ids from the questions
            payload.question_ids = this.shippingOption.question_ids.map(q => typeof q === 'object' ? q.value : q);

            this.$http
                .withClientId(store.getters['LRSettingsState/getShopifyUserId'])
                [method](url, payload)
                .then((data) => {
                    EventBus.$emit('show-success', 'Shipping option saved successfully.');
                    this.$emit('post-save');
                    this.$emit('update-label', this.shippingOption.label);
                    this.shippingOption = new ShippingOptionStruct(data.data.data);
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
                .finally(() => {
                    this.isSaving = false;
                });
        }
    }
}
</script>
